export const convertMinuteToUnit = (minutes: number) => {
    if (minutes < 0) {
        return undefined;
    }
    return minutes >= 720 ? 12 : 0; // 720 minutes = 12 hours
};

export const convertMinuteToHour = (minutes: number) => {
    if (minutes < 0) {
        return undefined;
    }
    return Math.floor(minutes / 60);
};

export const convertMinuteToMinute = (minutes: number) => {
    if (minutes < 0) {
        return undefined;
    }
    return minutes % 60;
};
